import React, {useMemo, useState} from "react";
import Button from "../../../../../components/button/button.jsx";
import { Modal } from "../../../../../components/modal/modal.jsx";
import { AgGridReact } from "ag-grid-react";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import {FaEye} from "react-icons/fa";
import ModalAttaches from "../../../../../components/modal/modal-attaches.jsx";

const ModalAttachesList = ({ open, setOpen, attaches }) => {
    if (!open) return null;

    const [modalAttaches, setModalAttaches] = useState({
        open: false,
        file: null
    });

    const openAttach = (attach) => {
        if (!attach?.attachId) return;

        setModalAttaches({
            open: true,
            file: attach
        });
    };

    const columnDefs = useMemo(() => [
        { headerName: "Nome", field: "name", flex: 1 },
        { headerName: "Descrição", field: "description", sort: "asc", flex: 2,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
        { headerName: "", width: 40, sortable: false,
            cellRenderer: ({ data }) => (
                <div className="flex justify-center">
                    <Button className="!px-2.5" title="Visualizar anexo" onClick={() => openAttach(data)}>
                        <FaEye />
                    </Button>
                </div>
            )
        }
    ], []);

    const theme = useMemo(
        () => aggridUtils.generalTheme(40, 40),
        []
    );

    const closeModalAttaches = () => {
        setModalAttaches(prev => ({
            ...prev,
            open: false
        }));
    };

    return (
        <>
            <Modal open={open} setOpen={setOpen} centered size="md" backdrop="static" keyboard={false} title={"Anexos"} className={"w-6/12"}>
                <Modal.Body className="p-3">
                    <div className="h-[400px]">
                        <AgGridReact
                            rowData={attaches || []}
                            columnDefs={columnDefs}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{ localeText: aggridUtils.localization() }}
                            rowHeight={35}
                            theme={theme}
                        />
                    </div>
                </Modal.Body>
            </Modal>

            <ModalAttaches
                open={modalAttaches.open}
                setOpen={closeModalAttaches}
                file={modalAttaches.file}
            />
        </>
    );
};

export default ModalAttachesList;